<template>
  <div class="flex-body">
    <div class="login-header">
      <div class="h-title">
        <p class="span-style" style="margin-top:24px;"> <el-page-header @back="goBack" content="修改密码"></el-page-header>
        </p>

      </div>

    </div>
    <div class="login-content">
      <div class="inline-div">
        <!-- <div class="login-text">
          习训云 - 实训管理平台
        </div> -->
        <div class="login-win">
          <h2>修改密码</h2>
          <!-- <i class="el-icon-info" style=""></i> -->
          <!-- <div class="school input">
            <span></span>
            <el-autocomplete class="school input" v-model="loginForm.school" focus :fetch-suggestions="querySearch" placeholder="请选择学校" @select="handleSelect"></el-autocomplete>
          </div> -->
          <!-- <div class="user input">
            <span></span>
            <el-input placeholder="请输入账号" v-model="loginForm.username">
            </el-input>
          </div> -->
          <p style="font-size: 13px;color: orange;">请包含大小写英文字母以及字符数字</p>
          <div class="password input">
            <span></span>
            <el-input type="password" placeholder="请输入旧密码" show-password v-model="loginForm.psw1">
            </el-input>
          </div>
          <div class="password input">
            <span></span>
            <el-input type="password" placeholder="请输入新密码" show-password v-model="loginForm.psw2">
            </el-input>
          </div>
          <div class="password input">
            <span></span>
            <el-input type="password" @keyup.enter.native="login" placeholder="请输入确认密码" show-password v-model="psw3">
            </el-input>
          </div>
          <div class="mistake-info">{{ message }}</div>
          <div class="login_btn">
            <el-button type="primary" @click="login">确认修改</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer">
      <!-- <p>万博云信（北京）教育科技有限公司</p>
      <p>Copyright © 2015-2016 Vanber. All Rights Reserved. 京ICP备15033449号-2</p>
      <p>院校咨询：189 1165 6408 渠道合作：135 2057 3697</p>
      <p>邮箱：xixun@vanber.cn</p>
      <p><img src="@/assets/image/ga.png" />京公网安备11010802031338号</p> -->
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        psw1: '',
        psw2: '',
      },
      psw3: '',
      message: '',
      restaurants: [],
    };
  },
  created() {

  },
  mounted() {
    // let storage = window.localStorage
    // if(storage.getItem("school")){
    //   this.loginForm.school = JSON.parse(storage.getItem("school")).value
    // }
    // this.restaurants = this.loadAll();
  },
  methods: {
    goBack() {
      history.back()
    },
    async login() {
      if (!this.loginForm.psw1) {
        this.message = '旧密码不能为空！';
        return;
      }
      if (!this.loginForm.psw2) {
        this.message = '新密码不能为空！';
        return;
      }
      if (!this.psw3) {
        this.message = '确认密码不能为空！';
        return;
      }
      if (this.psw3 != this.loginForm.psw2) {
        this.message = '两次密码输入不一致！';
        return;
      }
      this.message = '';
      let res = await this.$api.login.changePassword(this.loginForm);
      if (res.code == 0) {
        this.$message({
          message: '修改成功，请重新登录！',
          type: 'success',
          center: true,
        });
        this.$store.commit('setUserInfo', null);
        this.$store.commit('setMenu', null);
        this.$store.commit('setToken', null);
        this.$store.commit('setMenuItems', []);

        Cookies.remove('userToken');

        this.$router.push({
          path: '/login',
        });
      } else {
        // this.$message({
        //   message: res.msg,
        //   center: true,
        // });
      }
    },
    async getMenuItems() {
      let res = await this.$api.instance.getMenuItems({});
      if (res.code == 0 && res.data && res.data.menu) {
        // this.menuItems = res.data.menu;
        this.$store.commit('setMenu', res.data.menu);
        this.$router.push({
          path: '/quickEntry',
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.flex-body {
  display: flex;
  flex-direction: column;
  height: 100%;

  .login-header {
    height: 80px;
    width: 100%;
    border-top: 2px solid #4578ed;
    box-sizing: border-box;
    background: #fff;

    .h-title {
      height: 100%;
      margin: 0 auto;
      min-width: 1280px;
      text-align: left;
      line-height: 80px;
      margin-left: 72px;

      .span-style {
        font-size: 32px;
        font-weight: bold;
        color: #4578ed;
      }
    }
  }

  .login-content {
    background: #4578ed;
    width: 100%;
    min-width: 1280px;
    flex: 1;

    .inline-div {
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      // background: url('../assets/image/bac.png');
      background-size: 100% 100%;
    }
  }

  .login-footer {
    width: 100%;
    height: 160px;
    background: #fff;
    padding-top: 32px;
    font-size: 14px;
    border-bottom: 2px solid #4578ed;
    box-sizing: border-box;

    p {
      letter-spacing: 1px;
      margin-bottom: 2px;
      color: #111;
    }
  }
}

.login-text {
  position: relative;
  top: 50%;
  transform: translate(-50%, -50%);
  ;
  color: #fff;
  font-size: 48px;
  font-weight: bold;
  text-align: left;
  text-indent: 128px;
  left: 50%;
}

.login-win {
  position: relative;
  top: 50%;
  transform: translate(-50%, -50%);
  ;
  // height: 500px;
  width: 400px;
  background: #fefefe;
  margin-right: 0px;
  padding: 24px 0;
  text-align: center;
  border-radius: 5px;
  left: 50%;

  h2 {
    margin: 48px 0 32px;
  }

  i {
    font-size: 32px;
    color: #616f67;
    margin-bottom: 16px;
  }

  .input {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    padding-top: 24px;
  }

  .mistake-info {
    color: #de5050;
    text-align: left;
    font-size: 14px;
    width: 254px;
    margin: 8px auto;
    height: 25px;
  }
}

.login_btn {
  margin-top: 8px;
}

/deep/.el-input__inner {
  box-shadow: none;
  background: #d0e7ef5c;
  height: 48px;
  line-height: 48px;
  // font-weight: bold;
  color: #4578ed;
  // text-align: center;
  font-size: 16px;
  -webkit-box-shadow: 0 0 0px 1000px #d0e7ef5c inset;
  // -webkit-text-fill-color: #4578ed;
  border: 2px #616f6733 solid;
}

/deep/.el-button--primary {
  background-color: #4578ed;
  border-color: #cddacb;
  border-width: 2px;
  border: 2px #4578ed solid;
  color: #fefefe;
  font-weight: bold;
  letter-spacing: 4px;
  font-size: 16px;
  width: 120px;
}

/deep/ input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #b9bdd0;
}

/deep/ input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #b9bdd0;
}

/deep/ input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b9bdd0;
}

/deep/ input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #b9bdd0;
}
</style>